export default __webpack_public_path__ + "static/media/A1.f1e2de44.png";